import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Button, Box, IconButton,
  Drawer, List, ListItem, ListItemButton, ListItemText, Divider
} from '@mui/material';
import { Menu as MenuIcon, Close } from '@mui/icons-material';
import { navigateAndScroll } from '../../utils/navigation';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Home Assessment', path: '/home-assessment' },
  { label: 'Business Assessment', path: '/business-assessment' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (path) => {
    setMobileOpen(false);
    navigateAndScroll(navigate, path, location.pathname);
  };

  return (
    <>
      <AppBar position="sticky" elevation={0}
        sx={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #7c3aed 100%)' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box onClick={() => handleNav('/')}
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
            <Box component="img" src="/images/cwc-logo-full.png" alt="Cyber Wise Corp"
              sx={{ height: 72, objectFit: 'contain', borderRadius: 1 }} />
          </Box>

          {/* Desktop Nav */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5, alignItems: 'center' }}>
            {navLinks.map(link => (
              <Button key={link.path} color="inherit" onClick={() => handleNav(link.path)}
                sx={{ fontWeight: 500 }}>
                {link.label}
              </Button>
            ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Button variant="contained" size="small" onClick={() => handleNav('/book')}
              sx={{ backgroundColor: '#fbbf24', color: '#1e1e1e', boxShadow: '0 4px 20px rgba(0,0,0,0.4)', border: '2px solid #fbbf24', fontWeight: 600, display: { xs: 'none', sm: 'inline-flex' },
                '&:hover': { backgroundColor: '#f59e0b', boxShadow: '0 6px 25px rgba(0,0,0,0.5)', border: '2px solid #f59e0b' } }}>
              Book Assessment
            </Button>

            {/* Mobile menu button */}
            <IconButton color="inherit" onClick={() => setMobileOpen(true)}
              sx={{ display: { md: 'none' } }}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
        <Box sx={{ width: 280, pt: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, mb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>Menu</Typography>
            <IconButton onClick={() => setMobileOpen(false)}><Close /></IconButton>
          </Box>
          <Divider />
          <List>
            {navLinks.map(link => (
              <ListItem key={link.path} disablePadding>
                <ListItemButton onClick={() => handleNav(link.path)}>
                  <ListItemText primary={link.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
          <Box sx={{ p: 2 }}>
            <Button fullWidth variant="contained" onClick={() => handleNav('/book')}
              sx={{ background: 'linear-gradient(135deg, #2563eb, #7c3aed)', fontWeight: 600 }}>
              Book Assessment - $249.99
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export default Header;
